// extracted by mini-css-extract-plugin
export var grid = "_33-0";
export var span1 = "_33-2";
export var span10 = "_33-b";
export var span10L = "_33-z";
export var span10M = "_33-n";
export var span10Xl = "_33-1b";
export var span11 = "_33-c";
export var span11L = "_33-10";
export var span11M = "_33-o";
export var span11Xl = "_33-1c";
export var span12 = "_33-d";
export var span12L = "_33-11";
export var span12M = "_33-p";
export var span12Xl = "_33-1d";
export var span1L = "_33-q";
export var span1M = "_33-e";
export var span1Xl = "_33-12";
export var span2 = "_33-3";
export var span2L = "_33-r";
export var span2M = "_33-f";
export var span2Xl = "_33-13";
export var span3 = "_33-4";
export var span3L = "_33-s";
export var span3M = "_33-g";
export var span3Xl = "_33-14";
export var span4 = "_33-5";
export var span4L = "_33-t";
export var span4M = "_33-h";
export var span4Xl = "_33-15";
export var span5 = "_33-6";
export var span5L = "_33-u";
export var span5M = "_33-i";
export var span5Xl = "_33-16";
export var span6 = "_33-7";
export var span6L = "_33-v";
export var span6M = "_33-j";
export var span6Xl = "_33-17";
export var span7 = "_33-8";
export var span7L = "_33-w";
export var span7M = "_33-k";
export var span7Xl = "_33-18";
export var span8 = "_33-9";
export var span8L = "_33-x";
export var span8M = "_33-l";
export var span8Xl = "_33-19";
export var span9 = "_33-a";
export var span9L = "_33-y";
export var span9M = "_33-m";
export var span9Xl = "_33-1a";
export var stretch = "_33-1";